import { api } from "./api";

async function blobError(e) {
  const data = e?.response?.data;
  if (data instanceof Blob) {
    try { return JSON.parse(await data.text()).detail || "Download failed"; } catch { return "Download failed"; }
  }
  return e?.message || "Download failed";
}

/** Download a file from the API with the staff session, keeping the server's file name. */
export async function downloadFile(url, params, fallbackName) {
  try {
    const r = await api.get(url, { params, responseType: "blob" });
    const m = (r.headers["content-disposition"] || "").match(/filename="([^"]+)"/);
    const href = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = href;
    a.download = m ? m[1] : fallbackName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(href), 1500);
  } catch (e) {
    throw new Error(await blobError(e));
  }
}
